import { AssetInnerTable, ConstituentAsset } from '../asset-lookthrough-table'
import { Modal } from '../modals'

export type AssetConstituentModalProps = {
  data: ConstituentAsset[]
  header: string
  isOpen: boolean
  onClose: () => void
}

export const AssetConstituentModal = ({
  data,
  header,
  isOpen,
  onClose
}: AssetConstituentModalProps) => (
  <Modal.Wrapper
    aria-labelledby="asset-constituent-modal"
    isOpen={isOpen}
    width="lg"
    onClose={onClose}
  >
    {data && header ? (
      <>
        <Modal.Header id="asset-constituent-modal" onClose={onClose}>
          {header}
        </Modal.Header>
        <Modal.Body>
          <AssetInnerTable data={data} />
        </Modal.Body>
      </>
    ) : null}
  </Modal.Wrapper>
)
